(ns com.theplantscape.svg-generation.compat)

(def style-use-map? (atom #?(:cljs true :clj false)))
;; TODO drop hiccup and look into more compatible libs that are closer to reagent

(defn rkey [id]
  (if (true? @style-use-map?)
    {:key id}
    {}))

(defn style [m]
  (if (true? @style-use-map?)
    m
    (reduce (fn [s [k v]] (str s (name k) ":" v ";")) "" m)))

(defn switch-attribute [ra ha hm v]
  (if (true? @style-use-map?)
    (assoc hm ra v)
    (assoc hm ha v)))

(def view-box (partial switch-attribute :view-box :viewBox))
(def transform-origin (partial switch-attribute  :transformorigin :transform-origin))
(def std-deviation (partial switch-attribute  :std-deviation :stdDeviation))
(def base-frequency (partial switch-attribute  :base-frequency :baseFrequency))
(def num-octaves (partial switch-attribute :num-octaves :numOctaves))
(def x-channel-selector (partial switch-attribute :x-channel-selector :xChannelSelector))
(def y-channel-selector (partial switch-attribute :y-channel-selector :yChannelSelector))
